import { Observable, OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ActionCreator, AnyAction, Action } from 'typescript-fsa';
import { isTypeOfAny } from './isTypeOfAny';

export function isTypeOf<R>(
  actionFactory: ActionCreator<R>,
): OperatorFunction<AnyAction, Action<R>>;

export function isTypeOf<R1, R2>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2>>;

export function isTypeOf<R1, R2, R3>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3>>;

export function isTypeOf<R1, R2, R3, R4>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
  actionFactory4: ActionCreator<R4>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3> | Action<R4>>;

export function isTypeOf<R1, R2, R3, R4, R5>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
  actionFactory4: ActionCreator<R4>,
  actionFactory5: ActionCreator<R5>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3> | Action<R4> | Action<R5>>;

export function isTypeOf<R1, R2, R3, R4, R5, R6>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
  actionFactory4: ActionCreator<R4>,
  actionFactory5: ActionCreator<R5>,
  actionFactory6: ActionCreator<R6>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3> | Action<R4> | Action<R5> | Action<R6>>;

export function isTypeOf<R1, R2, R3, R4, R5, R6, R7>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
  actionFactory4: ActionCreator<R4>,
  actionFactory5: ActionCreator<R5>,
  actionFactory6: ActionCreator<R6>,
  actionFactory7: ActionCreator<R7>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3> | Action<R4> | Action<R5> | Action<R6> | Action<R7>>;

export function isTypeOf<R1, R2, R3, R4, R5, R6, R7, R8>(
  actionFactory1: ActionCreator<R1>,
  actionFactory2: ActionCreator<R2>,
  actionFactory3: ActionCreator<R3>,
  actionFactory4: ActionCreator<R4>,
  actionFactory5: ActionCreator<R5>,
  actionFactory6: ActionCreator<R6>,
  actionFactory7: ActionCreator<R7>,
  actionFactory8: ActionCreator<R8>,
): OperatorFunction<AnyAction, Action<R1> | Action<R2> | Action<R3> | Action<R4> | Action<R5> | Action<R6> | Action<R7> | Action<R8>>;

/* eslint-disable @typescript-eslint/no-explicit-any */
export function isTypeOf(...actionFactories: ActionCreator<Action<any>>[]): OperatorFunction<Action<any>, Action<any>> {
  const actionFactory = actionFactories[0];

  if (actionFactories.length === 1 && actionFactory !== undefined) {
    return (source: Observable<Action<any>>) => source.pipe(
      filter(actionFactory.match),
    );
  }

  return isTypeOfAny(actionFactories);
}
